import React from "react";

import FeedsFeature from "../features/board/components/Feeds";

function FeedCardDetail(props) {
  return <FeedsFeature {...props} showCardPopup={true} />;
}

export default FeedCardDetail;
